import { render, staticRenderFns } from "./parts-filters.vue?vue&type=template&id=b5822aea"
import script from "./parts-filters.vue?vue&type=script&lang=js"
export * from "./parts-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports